export default "__VITE_ASSET__3PAgLpNN__"